import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { Simdata5gAction } from 'src/actions/simdata5g.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getSimdata5gStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
  Button,
  Select,
  MenuItem,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

const Simdata5gLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedSimdata5gIds, setSelectedSimdata5gIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { role } = useSelector(state => state.profile);
  const { items, total, filter } = useSelector(state => state.simdata5g);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(Simdata5gAction.updateFilter(payload));
    dispatch(Simdata5gAction.list(page, limit))
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedSimdata5gIds;

    if (event.target.checked) {
      newSelectedSimdata5gIds = items.map((simdata5g) => simdata5g.id);
    } else {
      newSelectedSimdata5gIds = [];
    }

    setSelectedSimdata5gIds(newSelectedSimdata5gIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedSimdata5gIds.indexOf(id);
    let newSelectedSimdata5gIds = [];

    if (selectedIndex === -1) {
      newSelectedSimdata5gIds = newSelectedSimdata5gIds.concat(selectedSimdata5gIds, id);
    } else if (selectedIndex === 0) {
      newSelectedSimdata5gIds = newSelectedSimdata5gIds.concat(selectedSimdata5gIds.slice(1));
    } else if (selectedIndex === selectedSimdata5gIds.length - 1) {
      newSelectedSimdata5gIds = newSelectedSimdata5gIds.concat(selectedSimdata5gIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedSimdata5gIds = newSelectedSimdata5gIds.concat(
        selectedSimdata5gIds.slice(0, selectedIndex),
        selectedSimdata5gIds.slice(selectedIndex + 1)
      );
    }

    setSelectedSimdata5gIds(newSelectedSimdata5gIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, simdata5g) => {
    setSelected(simdata5g);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(Simdata5gAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(Simdata5gAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const approve = async (id, trang_thai_duyet) => {
    const question = trang_thai_duyet == 1 ? "Xác nhận duyệt đơn này?" : "Xác nhận từ chối đơn này?" ;
    if (window.confirm(question)) {
      try {
        const response = await dispatch(Simdata5gAction.approve(id, { trang_thai_duyet }));
        if (typeof response.channel !== 'undefined') alert("[Thông báo từ '"+response.channel+"']\n"+response.message+(response.status != "Unknown" ? (" ("+response.status+")") : ""));
        else if (typeof response.code !== 'undefined' && typeof response.msg !== 'undefined') alert("[Lỗi]\n"+response.msg)
      } catch (error) {
        if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
      }
    } else {
      
    }
  };

  const setTrangThai = async (id, trang_thai) => {
    const question = trang_thai == 'SUCCESS' ? "Xác nhận đặt trạng thái 'Thành công'?" : "Xác nhận đặt trạng thái 'Thất bại'?" ;
    if (window.confirm(question)) {
      try {
        const response = await dispatch(Simdata5gAction.setTrangThai(id, { trang_thai }));
        if (typeof response.channel !== 'undefined') alert("[Thông báo từ '"+response.channel+"']\n"+response.message+(response.status != "Unknown" ? (" ("+response.status+")") : ""));
        else if (typeof response.code !== 'undefined' && typeof response.msg !== 'undefined') alert("[Lỗi]\n"+response.msg)
      } catch (error) {
        if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
      }
    } else {
      
    }
  };

  const setColor = (value) => {
      if (value == 'MOBIFONE') return 'green';
      else if (value == 'VINAPHONE') return 'blue';
      else if (value == 'VIETTEL') return 'red';
      else return '#000000';
  };

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Tên
                </TableCell>
                <TableCell>
                  Hình ảnh
                </TableCell>
                <TableCell>
                  Giá
                </TableCell>
                <TableCell>
                  Nhà mạng
                </TableCell>
                <TableCell>
                  Thời hạn theo tháng
                </TableCell>
                <TableCell>
                  Ngày tạo
                </TableCell>
                <TableCell>
                  Người đăng
                </TableCell>
                <TableCell>
                  Người chỉnh cuối
                </TableCell>
                <TableCell>
                  Thao tác
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((simdata5g, index) => (
                <TableRow
                  hover
                  key={simdata5g.id}
                  selected={selectedSimdata5gIds.indexOf(simdata5g.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {simdata5g.name}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {simdata5g.image && <img style={{height: 30}} src={simdata5g.image} alt={simdata5g.title ? simdata5g.title : ''} />}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {(Number(simdata5g.price_new) > 0 && Number(simdata5g.price_new) < Number(simdata5g.price)) ? (
                        <div>
                          <span style={{ color: 'red', fontWeight: 'bold' }}>
                            {numeral(simdata5g.price_new).format('0,0')}₫
                          </span>
                          &nbsp;
                          <span className='price-old' style={{ textDecoration: 'line-through', color: '#888' }}>
                            {numeral(simdata5g.price).format('0,0')}₫
                          </span>
                        </div>
                      ) : (
                        <div>
                          <span style={{ fontWeight: 'bold' }}>
                            {numeral(simdata5g.price).format('0,0')}₫
                          </span>
                        </div>
                      )}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {simdata5g.operator == "MOBIFONE" && <span style={{color: setColor('MOBIFONE'), fontWeight: "bold"}}>MOBIFONE</span>}
                      {simdata5g.operator == "VINAPHONE" && <span style={{color: setColor('VINAPHONE'), fontWeight: "bold"}}>VINAPHONE</span>}
                      {simdata5g.operator == "VIETTEL" && <span style={{color: setColor('VIETTEL'), fontWeight: "bold"}}>VIETTEL</span>}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {`${simdata5g.time_by_month} tháng`}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {moment(simdata5g.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {simdata5g.username_dang_bai}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {simdata5g.username_chinh_sua_cuoi_cung}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <IconButton aria-label="edit" onClick={() => onSelected(simdata5g.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, simdata5g)}>
                      <Trash2Icon color='red' />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.ten_goi_cuoc} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default Simdata5gLookupDetail;
